// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import BootstrapVue from 'bootstrap-vue'
import ApiService from '@/common/api.service'
import vuescroll from 'vuescroll';
import VeeValidate from 'vee-validate'
import { config } from '@/config/validations.js'
import 'cropperjs/dist/cropper.min.css'
import 'vuescroll/dist/vuescroll.css'
import 'vue-toastr/dist/vue-toastr.min.css'
import VueToastr from 'vue-toastr'
import { initFilters } from '@/common/filters'
import { LoadingFormDirective, LoadingButtonDirective } from '@/directives/LoadingForm'
import i18n from './i18n'
import VueAnalytics from 'vue-analytics'
import * as Sentry from '@sentry/browser';
import { BrowserTracing } from "@sentry/tracing";
import * as firebase from "firebase/app";
import "firebase/performance";
import IntegrationsRoute from '@/router/integrations';
import VueMeta from 'vue-meta';
import VueAmplitude from "./modules/amplitude-module"; 

var SocialSharing = require('vue-social-sharing');

Vue.config.productionTip = false
ApiService.init()

Vue.use(BootstrapVue)
Vue.use(VeeValidate, config)
Vue.use(vuescroll)
Vue.use(VueMeta)
Vue.use(VueAmplitude,{apiKey:'e103b3720450c2c743bfd73344a8a470'})

const isProd = process.env.NODE_ENV === 'production'

if(isProd) {
  Vue.use(VueAnalytics, {
    id: 'UA-118087452-4',
    router,
    debug: {
      enabled: !isProd,
      sendHitTask: isProd
    }
  })

  Sentry.init({
    dsn: 'https://7094688ef0524f93b53a5c893f821208@sentry.io/1816764',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
  // Firebase
  const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: "player-web-app-4ec77.firebaseapp.com",
    databaseURL: "https://player-web-app-4ec77.firebaseio.com",
    projectId: "player-web-app-4ec77",
    storageBucket: "player-web-app-4ec77.appspot.com",
    messagingSenderId: "877125906965",
    appId: "1:877125906965:web:0fcdc9b45a79ca865d541c",
    measurementId: "G-HMLZ5J2JYB"
  };
  
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  
  // Initialize Performance Monitoring and get a reference to the service
  const perf = firebase.performance();
}

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-center',
  defaultTimeout: 4000,
  defaultProgressBar: false,
  defaultNewestOnTop: false
})
Vue.directive('loading-form', LoadingFormDirective)
Vue.directive('loading-button', LoadingButtonDirective)

initFilters(Vue)
Vue.prototype.$eventHub = new Vue()

const host = window.location.host;
const parts = host.split('.');

const setRouter = () => {
  let routes;
  // if subdomain is integration open IntegrationsRoute
  if (parts[0] === 'integration') {
    routes = IntegrationsRoute;
  } else {
    routes = router;
  }
  return routes;
};

new Vue({
  router: setRouter(),
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')